import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { safetyAnalyticsReducer } from './safety-analytics.reducer';
import { SafetyAnalyticsEffects } from './safety-analytics.effects';

/**
 * Safety analytics feature state module
 * Encapsulates all safety analytics state management
 */
@NgModule({
  imports: [
    StoreModule.forFeature('safetyAnalytics', safetyAnalyticsReducer),
    EffectsModule.forFeature([SafetyAnalyticsEffects])
  ]
})
export class SafetyAnalyticsStateModule {}
